var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-container"},[_c('div',{staticClass:"list-group"},_vm._l((_vm.menu),function(link,index){return _c('router-link',{key:'index'+index,staticClass:"list-group-item list-group-item-action",attrs:{"to":_vm.getRoute(link)}},[_vm._v("\n      "+_vm._s(link.label)+"\n    ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d58d3592","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Demo/Menu.vue
// module id = null
// module chunks = 